const initialState = {
  currencyData: null,
  loading: false,
  error: null,
};

export const currencyReducer = (state = initialState, action) => {
  switch (action.type) {
    case "EDIT_CURRENCY_REQUEST":
    case "FETCH_CURRENCY_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };

    case "EDIT_CURRENCY_SUCCESS":
    case "FETCH_CURRENCY_SUCCESS":
      return {
        ...state,
        loading: false,
        currencyData: action.payload.data || state.currencyData,
        error: null,
      };

    case "EDIT_CURRENCY_FAILURE":
    case "FETCH_CURRENCY_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
